import { AxiosRestApplicationClient as OnboardingAxiosRestApplicationClient } from '@g2-shared/api-client/generated/onboarding-app';
import {
  getServerErrorMessage,
  LoggingServiceAdapter,
  NotificationAdapter,
} from '@g2-shared/common';
import { generateBaseAxiosClient } from '@g2-shared/common/libs/baseAxiosClient';

export const FIND_PARTY_TYPES = 'FIND_PARTY_TYPES';
export const FIND_PARTY_TYPE_BY_ID = 'FIND_PARTY_TYPE_BY_ID';

export const FIND_PARTY_TYPES_BY_APPLICATION_ID = 'FIND_PARTY_TYPES_BY_APPLICATION_ID';

export const partyTypeApiDefaultConfig = {
  retry: undefined,
};

export const usePartyTypeApiDefaultConfig = (callerName: string) => {
  const { logError } = LoggingServiceAdapter();
  const { translateAndNotifyError } = NotificationAdapter();

  return {
    ...partyTypeApiDefaultConfig,
    onError: (error: unknown) => {
      translateAndNotifyError(getServerErrorMessage(error));
      logError(error, 'Error while calling onboarding Party type api', callerName);
    },
  };
};

const { VITE_APP_GATEWAY_BASE_URL } = import.meta.env;

export const onboardingAxiosClient = new OnboardingAxiosRestApplicationClient(
  VITE_APP_GATEWAY_BASE_URL,
  generateBaseAxiosClient({ baseURL: VITE_APP_GATEWAY_BASE_URL })
);
